module.exports = __webpack_public_path__ + "static/img/tft.c966247.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/games/games_colorful/tft.svg
// module id = uG/y
// module chunks = 35